import React, { useCallback } from 'react';
import * as S from './SkipLink.styled';

const MAIN_ID = 'conteudo-principal';

/**
 * Primeiro link da página → salta blocos repetidos (menu/header) para o main.
 * HashRouter: preventDefault evita trocar a rota (#/…) por #conteudo-principal.
 */
function SkipLink() {
  const handleClick = useCallback(event => {
    event.preventDefault();
    const main = document.getElementById(MAIN_ID);
    if (!main) {
      return;
    }
    main.focus({ preventScroll: false });
    main.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, []);

  return (
    <S.SkipLink href={`#${MAIN_ID}`} onClick={handleClick}>
      Ir para o conteúdo principal
    </S.SkipLink>
  );
}

export default SkipLink;
